import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { PagesModule } from '../../assets/pages/components/pages.module';
import { pgTabsModule } from '../../assets/pages/components/tabs/tabs.module';

import * as moduleComponents from './components';
import * as moduleContainers from './containers';
import * as moduleEffects from './effects';
import * as moduleGuards from './guards';
import * as moduleServices from './services';
import * as moduleDirectives from './directives';

import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '@progress/kendo-angular-layout';

import { environment } from '../../environments/environment';
import { EnvironmentEnum } from '../../environments/environment.interface';
import { GridModule } from '@progress/kendo-angular-grid';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    moduleComponents.ComingSoonComponent,
    moduleComponents.AppComponent,
    moduleComponents.HeaderComponent,
    moduleComponents.AppSidebarComponent,
    moduleComponents.PdfComponent,
    moduleComponents.FooterComponent,
    moduleComponents.WarningDialogComponent,
    moduleComponents.PdfComponent,
    moduleComponents.TermsAndConditionsComponent,
    moduleComponents.OperatorSelectionListComponent,
    moduleComponents.OperatorSelectionLookupFormComponent,

    moduleContainers.LandingComponent,
    moduleContainers.AccessDeniedPageComponent,
    moduleContainers.NotFoundPageComponent,
    moduleContainers.DebugComponent,
    moduleContainers.ErrorPageComponent,
    moduleContainers.StatusPageComponent,
    moduleContainers.OperatorSelectionDialogComponent,

    moduleDirectives.ClickOutsideDirective,
  ],
  imports: [
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    DropDownsModule,
    CommonModule,
    FormsModule,
    PagesModule,
    pgTabsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    LayoutModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    GridModule,
    EffectsModule.forFeature([
      moduleEffects.UserEffects,
      moduleEffects.ApiStatusEffects,
      moduleEffects.OperatorCollectionEffects,
    ]),
  ],
  providers: [
    moduleGuards.UserAgreementGuard,
    moduleGuards.UserAgreementAcceptedGuard,
    {
      provide: moduleServices.GIT_ENV_VARIABLES_SERVICE_TOKEN,
      useClass: moduleServices.GitEnvVariablesService
    },
    {
      provide: moduleServices.API_STATUS_SERVICE_TOKEN,
      useClass: moduleServices.ApiStatusService
    },
    {
      provide: moduleServices.OPERATOR_SERVICE_TOKEN,
      useClass: environment.environment !== EnvironmentEnum.LOCAL
        ? moduleServices.OperatorService
        : moduleServices.OperatorMockService
    }
  ],
  exports: [
    moduleComponents.ComingSoonComponent,
    moduleComponents.WarningDialogComponent,
    moduleComponents.PdfComponent,
    moduleComponents.TermsAndConditionsComponent,
    moduleComponents.OperatorSelectionListComponent,
    moduleComponents.OperatorSelectionLookupFormComponent,

    moduleContainers.OperatorSelectionDialogComponent,
  ]
})
export class CoreModule {
}
